import gql from 'graphql-tag';

const MUTATION_CREATE_REFERRAL = gql`
	mutation CreateReferral($userID: String, $email: String!, $type: Int!) {
		createReferral(userID: $userID, email: $email, type: $type)
	}
`;

export default MUTATION_CREATE_REFERRAL;